
import { useState } from 'react';
import { videos } from '../../../mocks/videos';

export default function VideoCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % videos.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? videos.length - 1 : prev - 1));
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Video <span className="text-teal-600">Gallery</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Watch our product demonstrations and company highlights
          </p>
        </div>

        <div className="max-w-4xl mx-auto relative">
          <div className="relative aspect-video rounded-lg overflow-hidden shadow-xl">
            <iframe
              src={videos[currentIndex].url}
              title={videos[currentIndex].title}
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>

          <div className="mt-6 text-center">
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              {videos[currentIndex].title}
            </h3>
            <p className="text-sm text-gray-600">
              {videos[currentIndex].description}
            </p>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/3 -translate-y-1/2 -translate-x-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-teal-600 hover:text-white transition-all duration-300 cursor-pointer"
            aria-label="Previous video"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/3 -translate-y-1/2 translate-x-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-teal-600 hover:text-white transition-all duration-300 cursor-pointer"
            aria-label="Next video"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-8 space-x-2">
            {videos.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  currentIndex === index
                    ? 'bg-teal-600 w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Go to video ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
